import { render, staticRenderFns } from "./Droparea.vue?vue&type=template&id=4446d679&"
import script from "./Droparea.vue?vue&type=script&lang=ts&"
export * from "./Droparea.vue?vue&type=script&lang=ts&"
import style0 from "./Droparea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports